import {
  XuxInputComponent,
  XuxInputRadioComponent,
  XuxInputSwitchComponent,
  XuxInputDateI18nComponent,
} from '@geniuspos/ui-shared/modules/xdm-shared-components/components';

import { XuxEditGridComponent } from './xux-edit-grid/xux-edit-grid-widget.component';
import { XuxGridListComponent } from './xux-grid-list/xux-grid-list-widget.component';
import { CommissionRateAssignmentGridWidgetComponent } from './commission-rate-assignment-grid/commission-rate-assignment-grid-widget.component';

import { WIDGET_COMPONENT } from '@shared/types';
import { XuxPanelGroupComponent } from './xux-panel-group/xux-panel-group.component';
import { XuxInputEntitySelectComponent } from './xux-input-entity-select/xux-input-entity-select.component';
import { XuxInputSelectComponent } from './xux-input-select/xux-input-select.component';
import { XuxSelectMenuComponent } from './xux-select-menu/xux-select-menu.component';
import { XuxInputEntitySelectMenuComponent } from './xux-input-entity-select/xux-input-entity-select-menu/xux-input-entity-select-menu.component';
import { XuxXVIInputDateComponent } from './xux-xvi-input-date';
import { XuxInputCurrencyComponent } from './xux-input-currency/xux-input-currency.component';
import { XuxSiteSelectionListComponent } from '@components/xux/xux-site-selection-list/xux-site-selection-list.component';
import { XuxSelectEventWithGridModalComponent } from './xux-select-event-with-grid-modal/xux-select-event-with-grid-modal-widget.component';
import { XuxEditGridCustomComponent } from '@components/xux/xux-edit-grid/xux-edit-grid-widget-custom.component';
import { XuxInputCheckboxGroupComponent } from './xux-input-checkbox-group/xux-input-checkbox-group.component';
import { XuxExpandCollapseIconComponent } from './xux-expand-collapse-icon/xux-expand-collapse-icon.component';
import { XUXEntityFormListComponent } from './xux-entity-form-list/xux-entity-form-list.component';
import { XUXMultipleLabelComponent } from './xux-multiple-label/xux-multiple-label.component';
import { XuxTransferSummaryComponent } from '../form/components/xux-transfer-summary/xux-transfer-summary.component';
import { XuxXVIInputComponent } from './xux-xvi-input/xux-xvi-input.component';
import { XuxSelectSiteWithGridModalComponent } from './xux-select-site-with-grid-modal/xux-select-site-with-grid-modal-widget.component';
import { XuxProgressBarComponent } from './xux-progress-bar/xux-progress-bar.component';
import { XuxEventSummaryComponent } from '../form/components/xux-event-summary/xux-event-summary.component';
import { XuxInventoryValueCardComponent } from '../form/components/xux-inventory-value-card/xux-inventory-value-card.component';
import { XuxInventoryOrderSummaryCardComponent } from '../form/components/xvi-purchase-order-card/xvi-purchase-order-summary-card.component';
import { XuxStandWorksheetSummaryComponent } from '../form/components/xux-stand-worksheet-summary/xux-stand-worksheet-summary.component';
import { XuxMultiSelectionListComponent } from './xux-multi-selection-list/xux-multi-selection-list.component';
import { XuxInputCheckboxComponent } from './xux-input-checkbox/xux-input-checkbox.component';

// for drag dynamic component declarations
export const dragComponents = [
  XuxTransferSummaryComponent,
  XuxEventSummaryComponent,
  XuxInventoryValueCardComponent,
  XuxInventoryOrderSummaryCardComponent,
  XuxStandWorksheetSummaryComponent,
];

/**
 * uses for getting widget class while a component is building in dnd dynamically
 */
export const xuxDndDynamicComponentsMap = {
  [WIDGET_COMPONENT.transfer_summary]: XuxTransferSummaryComponent,
  [WIDGET_COMPONENT.order_summary]: XuxTransferSummaryComponent,
  [WIDGET_COMPONENT.progress_bar]: XuxProgressBarComponent,
  [WIDGET_COMPONENT.event_summary]: XuxEventSummaryComponent,
  [WIDGET_COMPONENT.inventory_value]: XuxInventoryValueCardComponent,
  [WIDGET_COMPONENT.purchase_order_summary]:
    XuxInventoryOrderSummaryCardComponent,
  [WIDGET_COMPONENT.stand_worksheet_summary]: XuxStandWorksheetSummaryComponent,
};

/**
 * uses for getting widget class while a component is building dynamically
 */
export const xuxDynamicComponentsMap = {
  [WIDGET_COMPONENT.input]: XuxInputComponent,
  [WIDGET_COMPONENT.edit_grid]: XuxEditGridComponent,
  [WIDGET_COMPONENT.edit_grid_custom]: XuxEditGridCustomComponent,
  [WIDGET_COMPONENT.commission_rate_assignment_grid]:
    CommissionRateAssignmentGridWidgetComponent,
  [WIDGET_COMPONENT.grid_list]: XuxGridListComponent,
  [WIDGET_COMPONENT.input_currency]: XuxInputCurrencyComponent,
  [WIDGET_COMPONENT.panel_group]: XuxPanelGroupComponent,
  [WIDGET_COMPONENT.input_date]: XuxXVIInputDateComponent,
  [WIDGET_COMPONENT.input_radio]: XuxInputRadioComponent,
  [WIDGET_COMPONENT.select]: XuxInputSelectComponent,
  [WIDGET_COMPONENT.input_checkbox]: XuxInputCheckboxComponent,
  [WIDGET_COMPONENT.checkbox_group]: XuxInputCheckboxGroupComponent,
  [WIDGET_COMPONENT.entity_select]: XuxInputEntitySelectComponent,
  [WIDGET_COMPONENT.switch]: XuxInputSwitchComponent,
  [WIDGET_COMPONENT.site_selection_list]: XuxSiteSelectionListComponent,
  [WIDGET_COMPONENT.select_event_with_grid_modal]:
    XuxSelectEventWithGridModalComponent,
  [WIDGET_COMPONENT.select_site_with_grid_modal]:
    XuxSelectSiteWithGridModalComponent,
  [WIDGET_COMPONENT.xux_datepicker]: XuxInputDateI18nComponent,
  [WIDGET_COMPONENT.entity_form_list]: XUXEntityFormListComponent,
  [WIDGET_COMPONENT.multiple_label]: XUXMultipleLabelComponent,
  [WIDGET_COMPONENT.xux_xiv_input]: XuxXVIInputComponent,
  [WIDGET_COMPONENT.multiple_selection_list]: XuxMultiSelectionListComponent,

  // for drag
  ...xuxDndDynamicComponentsMap,
};

export const xviDynamicComponentsDependencies = [
  XuxSelectMenuComponent,
  XuxInputEntitySelectMenuComponent,
];

/**
 * aggregate array of components which will be added to
 * widgets should be added to the providers and exports of XVIComponentsModule
 */

export const xviDynamicComponents = [
  XuxEditGridComponent,
  XuxEditGridCustomComponent,
  CommissionRateAssignmentGridWidgetComponent,
  XuxGridListComponent,
  XuxInputSelectComponent,
  XuxInputCheckboxComponent,
  XuxInputCheckboxGroupComponent,
  XuxXVIInputDateComponent,
  XuxInputEntitySelectComponent,
  XuxInputCurrencyComponent,
  XUXEntityFormListComponent,
  XuxPanelGroupComponent,
  XuxSiteSelectionListComponent,
  XuxExpandCollapseIconComponent,
  XUXMultipleLabelComponent,
  XuxMultiSelectionListComponent,
  XuxXVIInputComponent,
  XuxTransferSummaryComponent,
  ...xviDynamicComponentsDependencies,
  ...dragComponents,
];

/**
 * array of dynamic widgets imported from @geniuspos/ui-shared module
 * widgets must be added to entryComponents in the xvi.components.module for ability to build on fly
 */
export const xuxDynamicComponents = [XuxInputComponent, XuxInputRadioComponent];
